import { Row } from 'antd';
import IconComponent from 'components/common/IconComponent';
import React, { CSSProperties, ReactElement } from 'react';
import styled from 'styled-components';

const ContainerStyled = styled(Row)`
  flex-wrap: nowrap;
  & .gx-page-title {
    display: flex;
    align-items: center;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 18px;
    color: #545454;
  }
`;

const ContainerHeader: React.FC<{
  children?: ReactElement | string;
  className?: string;
  title?: ReactElement | string;
  headerIconName?: string;
  style?: CSSProperties;
  headerButton?: ReactElement;
}> = ({ children, className, title, headerIconName, style, headerButton }) => (
  <ContainerStyled className={`gx-m-0 common-page-header ${className}`} align='middle' style={style}>
    <div className='gx-page-heading  gx-m-0 gx-mr-3'>
      <h2 className='gx-page-title'>
        {headerIconName && (
          <div style={{ display: 'inline-block', marginRight: 10 }} className='common-page-header-icon'>
            <IconComponent name={headerIconName} size={22} />
          </div>
        )}
        <div>{title}</div>
      </h2>
    </div>
    {headerButton && <div className='header-side gx-mr-3'>{headerButton}</div>}
    {children && <div className='header-side gx-flex-1'>{children}</div>}
  </ContainerStyled>
);

export default ContainerHeader;
